"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCellRenderer = void 0;
var tslib_1 = require("tslib");
var dataSourceUtils_1 = require("../data/dataSourceUtils");
var escape_1 = tslib_1.__importDefault(require("lodash/escape"));
var constants_1 = require("../base/constants");
var tableDescriptorTypes_1 = require("../structure/tableDescriptorTypes");
function hasTotalForCurrentColumn(params) {
    var row = params.data;
    if (!(row === null || row === void 0 ? void 0 : row.calculatedForColumns) || !params.colDef) {
        return false;
    }
    var colId = tableDescriptorTypes_1.agColId(params.colDef);
    return row.calculatedForColumns.some(function (col) { return col === colId; });
}
/**
 * Returns common implementation of cell renderer used for normal cells, sticky header cells and totals.
 *
 * TODO: Consider to use custom pinnerRowCellRenderer in order to reduce number of conditionals
 */
function createCellRenderer() {
    return function (params) {
        var _a;
        var isRowTotalOrSubtotal = dataSourceUtils_1.isSomeTotal((_a = params.data) === null || _a === void 0 ? void 0 : _a.type);
        var isActiveRowTotal = isRowTotalOrSubtotal && hasTotalForCurrentColumn(params);
        var formattedValue = isRowTotalOrSubtotal && !isActiveRowTotal && !params.value
            ? "" // inactive row total cells should be really empty (no "-") when they have no value (RAIL-1525)
            : escape_1.default(params.formatValue(params.value));
        var className = params.node.rowPinned === "top" ? "gd-sticky-header-value" : constants_1.VALUE_CLASS;
        return "<span class=\"" + className + "\">" + (formattedValue || "") + "</span>";
    };
}
exports.createCellRenderer = createCellRenderer;
//# sourceMappingURL=cellRenderer.js.map